export default "__VITE_ASSET__DzYCNn0D__"